var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root lx-add-this addthis_inline_share_toolbox"})}
var staticRenderFns = []

export { render, staticRenderFns }